module.exports = __webpack_public_path__ + "static/how-video-bg-f77990b1f54d3415e867c7dba1cb8010.png";